/**
 * Evidenziatore animato sui <mark> dello shortcode [u]…[/u].
 *
 * All'entrata in viewport la banda accent viene "tracciata" da sinistra verso
 * destra, come un colpo di pennarello. Una volta sola per marker.
 *
 * Il disegno resta interamente CSS (_shortcode.scss): il JS anima solo la
 * custom property --am-mark-fill, che pilota il background-size del <mark>.
 * Si usa il background nativo — e non overlay assoluti — perché il <mark> è
 * inline e va a capo: con box-decoration-break: clone ogni frammento di riga si
 * riempie dal proprio bordo sinistro, senza DOM aggiuntivo né ricalcoli su
 * resize o font-load.
 *
 * Markup: <mark class="mark-anim js-evidenzia"> — am_underline_shortcode()
 * in functions.php.
 *
 * prefers-reduced-motion è gestito in CSS (banda già piena), qui si esce e basta.
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

( function () {
	'use strict';

	const marks = document.querySelectorAll( '.js-evidenzia' );
	if ( ! marks.length ) {
		return;
	}

	if ( window.matchMedia && window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return; // il CSS ha già ripristinato --am-mark-fill: 100%.
	}

	gsap.registerPlugin( ScrollTrigger );

	// Attacco rapido + decelerazione: la dinamica di un tratto di pennarello.
	// Il target 104% (l'eccedenza viene tagliata dal box) fa arrivare il tratto
	// al bordo destro con velocità ancora residua, invece di spegnersi
	// sull'ultimo pixel.
	const draw = ( targets ) => gsap.to( targets, {
		'--am-mark-fill': '104%',
		duration: 1,
		ease: 'power2.out',
		stagger: 0.12,
	} );

	// I marker già visibili al caricamento non aspettano lo scroll: un [u]…[/u]
	// dentro un occhiello o un sottotitolo di header sta above the fold e
	// resterebbe altrimenti bianco finché non si scorre.
	const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
	const visible = [];
	const deferred = [];

	Array.prototype.forEach.call( marks, ( mark ) => {
		const rect = mark.getBoundingClientRect();
		const onScreen = rect.top < viewportHeight && rect.bottom > 0;
		( onScreen ? visible : deferred ).push( mark );
	} );

	if ( visible.length ) {
		requestAnimationFrame( () => draw( visible ) );
	}

	if ( deferred.length ) {
		// batch() raggruppa da sé i marker che entrano insieme, così due <mark>
		// vicini partono in sequenza (stagger) invece che all'unisono.
		ScrollTrigger.batch( deferred, {
			start: 'top 85%',
			once: true,
			onEnter: draw,
		} );
	}
}() );
